import { render, staticRenderFns } from "./AiChatFloat.vue?vue&type=template&id=640af73c&scoped=true"
import script from "./AiChatFloat.vue?vue&type=script&lang=js"
export * from "./AiChatFloat.vue?vue&type=script&lang=js"
import style0 from "./AiChatFloat.vue?vue&type=style&index=0&id=640af73c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640af73c",
  null
  
)

export default component.exports